import { render, staticRenderFns } from "./LogoPausentaste.vue?vue&type=template&id=f4c3c11a&scoped=true&"
import script from "./LogoPausentaste.vue?vue&type=script&lang=js&"
export * from "./LogoPausentaste.vue?vue&type=script&lang=js&"
import style0 from "./LogoPausentaste.vue?vue&type=style&index=0&id=f4c3c11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c3c11a",
  null
  
)

export default component.exports